import { AppState } from "features";

export const getSelectedRegion = ({ region: { selectedRegion } }: AppState) => {
    return selectedRegion;
};
